import React from "react";
import s from "../../labReport/labReportPdf.module.scss";
import styles from "./cultureReport.module.scss";

const CultureReport = ({ profile, PageBaseLayout, PageFooter }) => {
  if (!profile) return null;

  const chunkArray = (array, size) => {
    const result = [];
    if (!array) return result;
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  const antibioticChunks = chunkArray(profile.tests || [], 24);

  return (
    <>
      {antibioticChunks.map((chunk, pageIndex) => (
        <div
          key={`culture-page-${pageIndex}`}
          className={s.reportPage}
          style={{ pageBreakAfter: "always" }}
        >
          <PageBaseLayout
            showSampleType={true}
            currentSampleType={profile?.testSampleType?.name || "-"}
          />

          <div className={styles.cultureReportContainer}>
            {pageIndex === 0 && (
              <>
                <h2 className={styles.mainHeader}>MICROBIOLOGY REPORT</h2>
                <div className={s.profileCategoryRow}>
                  <span colSpan={2}
                      style={{
                        textAlign: "center",
                        fontSize: "12px",
                        fontWeight: "900",
                        color: "#4d4dcf",
                        borderBottom: "none",
                      }}>{profile?.profileName || ""}</span>
                </div>

                <div className={styles.organismInfo}>
                  <div className={styles.infoRow}>
                    <span className={styles.label}>Organism</span>
                    <span className={styles.value}>
                      : {profile?.organism || "-"}
                    </span>
                  </div>

                  <div className={styles.infoRow}>
                    <span className={styles.label}>Colony Count</span>
                    <span className={styles.value}>
                      : {profile?.colonyCount || "-"}
                    </span>
                  </div>

                  <div className={styles.infoRow}>
                    <span className={styles.label}>Method</span>
                    <span className={styles.value}>
                      : {profile?.testMethod?.name || "-"}
                    </span>
                  </div>
                </div>
              </>
            )}

            <table className={s.resultsTable}>
              <thead>
                <tr>
                  <th style={{ width: "75%" }}>Antibiotic Name</th>
                  <th style={{ textAlign: "center", width: "25%" }}>
                    Interpretation
                  </th>
                </tr>
              </thead>

              <tbody>
                {/* {pageIndex === 0 && (
                  <tr className={s.profileCategoryRow}>
                    <td
                      colSpan={2}
                      style={{
                        textAlign: "center",
                        fontSize: "11px",
                        fontWeight: "900",
                        padding: "8px",
                        color: "#4d4dcf",
                        textTransform: "uppercase",
                        background: "#4fd96d",
                        borderBottom: "none",
                      }}
                    >
                      {profile?.profileName || "ANTIBIOTIC SENSITIVITY"}
                    </td>
                  </tr>
                )} */}

                <tr className={s.sectionHeaderRow}>
                  <td
                    style={{
                      textAlign: "center",
                      fontSize: "11px",
                      fontWeight: "700",
                      padding: "4px 8px",
                      color: "#4d4dcf",
                      background: "#fff",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    ANTIBIOTIC SENSITIVITY
                  </td>
                </tr>

                {chunk.map((test, idx) => (
                  <tr key={idx}>
                    <td style={{ paddingLeft: "15px", borderBottom: "none" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          flexWrap: "wrap",
                          gap: "6px",
                        }}
                      >
                        <strong>{test?.testName}</strong>

                        {test?.method && (
                          <span
                            style={{
                              fontSize: "8px",
                              color: "#666",
                              fontStyle: "italic",
                            }}
                          >
                            ({test.method})
                          </span>
                        )}
                      </div>
                    </td>

                    <td
                      align="center"
                      style={{
                        borderBottom: "none",
                        fontWeight: "600",
                      }}
                    >
                      {test?.value || "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {pageIndex === antibioticChunks.length - 1 && (
              <div className={styles.finalSection}>
                <div className={styles.interpretationLegend}>
                  <p>
                    <strong>Interpretation:</strong> All reports need clinical
                    correlation. Kindly discuss if necessary. No part of this
                    report can be reproduced without written permission of the
                    department.
                  </p>

                  <p>
                    <strong>Susceptible (S):</strong> Infection is expected to
                    respond to treatment with higher doses.
                  </p>

                  <p>
                    <strong>Intermediate (I):</strong> Infection may or may not
                    respond to treatment with higher doses.
                  </p>

                  <p>
                    <strong>Susceptible Dose Dependent (SDD):</strong> Infection
                    may respond to treatment with higher doses.
                  </p>

                  <p>
                    <strong>Non-Susceptible (NS):</strong> Isolates for which
                    only a susceptible breakpoint is available because of the
                    absence or rare occurrence of resistant strains.
                  </p>

                  <p>
                    <strong>Resistant (R):</strong> Clinical response is
                    unlikely even with maximum tolerated doses.
                  </p>
                </div>

                {profile?.comment && (
                  <div className={styles.commentsSection}>
                    <strong>Comments:</strong> {profile.comment}
                  </div>
                )}
              </div>
            )}
          </div>

          <PageFooter />
        </div>
      ))}
    </>
  );
};

export default CultureReport;